import React from "react";
import ConfirmationModal from "../common/ConfirmationModal";

interface ConfirmMigrationEntityBlockUpdateConfig {
  migrationEntityType: string;
}

interface ConfirmMigrationEntityBlockUpdateModalProps {
  open: boolean;
  entityKey: string;
  isBlocked: boolean;
  config: ConfirmMigrationEntityBlockUpdateConfig;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmMigrationEntityBlockUpdateModal: React.FC<ConfirmMigrationEntityBlockUpdateModalProps> = ({
  open,
  entityKey,
  isBlocked,
  config,
  onClose,
  onConfirm,
}) => {
  const getMessage = (): string => {
    const action = isBlocked ? "block" : "unblock";
    return `Are you sure you want to ${action} ${config.migrationEntityType} ${entityKey} migration?`;
  };
  const getStatusColor = (): "warning" | "lime" => isBlocked ? "warning" : "lime";
  const getButtonText = (): string => isBlocked ? "Block" : "Unblock";

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      message={getMessage()}
      statusColor={getStatusColor()}
      buttonText={getButtonText()}
    />
  );
};

export default ConfirmMigrationEntityBlockUpdateModal;

export const MIGRATION_ENTITY_BLOCK_UPDATE_CONFIGS = {
  CASE: {
    migrationEntityType: "case",
  },
  INTAKE: {
    migrationEntityType: "intake",
  },
  PROVIDER: {
    migrationEntityType: "provider",
  },
  FIRM_DOCUMENTS_FOLDER: {
    migrationEntityType: "firm",
  },
  TEMPLATE: {
    migrationEntityType: "template",
  },
} as const;
